/*
  Product photo zoom (main-product + main-product-signup sections).

  Zoom only happens when the shopper asks for it (no hover magnifier):
  - Any device: clicking/tapping the main photo (or the zoom button) opens a full-screen viewer
    with pinch / double-tap / wheel zoom, drag to pan, swipe or arrows to
    move between photos, and Esc to close.

  Works off the live DOM (#PdpMainImage + [data-pdp-thumb]) so it keeps
  working after product-sibling-toggle.js swaps in the Sweetened/Unsweetened
  sibling's photos. Zoom images are the same Shopify CDN URLs with
  width=2048; the CDN never upscales past the original upload.
*/
(function () {
  var main = document.getElementById('PdpMainImage');
  if (!main) return;
  var media = main.closest('.pdp-media');
  if (!media) return;

  var ZOOM_WIDTH = 2048;
  var TAP_SCALE = 2.5;
  var MAX_SCALE = 4;

  function zoomSrc(src) {
    if (!src) return src;
    if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + ZOOM_WIDTH);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + ZOOM_WIDTH;
  }

  function photoList() {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-thumb]'));
    if (!thumbs.length) return { srcs: [main.currentSrc || main.src], index: 0 };
    var index = 0;
    var srcs = thumbs.map(function (b, i) {
      if (b.classList.contains('is-active')) index = i;
      return b.getAttribute('data-src');
    });
    return { srcs: srcs, index: index };
  }

  /* ---------- hint button ---------- */
  var hint = document.createElement('button');
  hint.type = 'button';
  hint.className = 'pdp-zoom-hint';
  hint.setAttribute('aria-label', 'Zoom photo');
  hint.innerHTML =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  media.appendChild(hint);
  media.classList.add('has-zoom');

  // Mouse users get click-to-zoom hints inside the viewer; touch users get pinch/double-tap.
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- full-screen viewer ---------- */
  var box, stage, img, counter, prevBtn, nextBtn, closeBtn, lastFocus;
  var srcs = [];
  var current = 0;
  var scale = 1, tx = 0, ty = 0;

  function build() {
    box = document.createElement('div');
    box.className = 'pdp-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product photo viewer');
    box.hidden = true;
    box.innerHTML =
      '<div class="pdp-lightbox__stage"><img class="pdp-lightbox__img" alt=""></div>' +
      '<button type="button" class="pdp-lightbox__btn pdp-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="pdp-lightbox__btn pdp-lightbox__prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="pdp-lightbox__btn pdp-lightbox__next" aria-label="Next photo">&#8250;</button>' +
      '<div class="pdp-lightbox__bar"><span class="pdp-lightbox__count"></span><span class="pdp-lightbox__tip"></span></div>';
    document.body.appendChild(box);
    stage = box.querySelector('.pdp-lightbox__stage');
    img = box.querySelector('.pdp-lightbox__img');
    counter = box.querySelector('.pdp-lightbox__count');
    prevBtn = box.querySelector('.pdp-lightbox__prev');
    nextBtn = box.querySelector('.pdp-lightbox__next');
    closeBtn = box.querySelector('.pdp-lightbox__close');
    box.querySelector('.pdp-lightbox__tip').textContent = canHover
      ? 'Click or scroll to zoom · drag to move'
      : 'Pinch or double-tap to zoom';

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    box.addEventListener('keydown', onKey);
    bindGestures();
  }

  function apply(animate) {
    img.style.transition = animate ? 'transform 0.2s ease' : 'none';
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    img.style.cursor = scale > 1 ? 'grab' : (canHover ? 'zoom-in' : 'default');
  }

  function clamp() {
    var W = stage.clientWidth, H = stage.clientHeight;
    var w = img.clientWidth * scale, h = img.clientHeight * scale;
    var mx = Math.max(0, (w - W) / 2), my = Math.max(0, (h - H) / 2);
    tx = Math.min(mx, Math.max(-mx, tx));
    ty = Math.min(my, Math.max(-my, ty));
  }

  // Zoom to `next` keeping the screen point (px, py) — relative to the stage center — fixed.
  function zoomAt(next, px, py, animate) {
    next = Math.min(MAX_SCALE, Math.max(1, next));
    tx = px - (next * (px - tx)) / scale;
    ty = py - (next * (py - ty)) / scale;
    scale = next;
    if (scale === 1) { tx = 0; ty = 0; }
    clamp();
    apply(animate);
  }

  function stagePoint(clientX, clientY) {
    var r = stage.getBoundingClientRect();
    return { x: clientX - (r.left + r.width / 2), y: clientY - (r.top + r.height / 2) };
  }

  function show(i) {
    current = (i + srcs.length) % srcs.length;
    scale = 1; tx = 0; ty = 0;
    apply(false);
    img.src = zoomSrc(srcs[current]);
    img.alt = (main.getAttribute('alt') || '') + ' — photo ' + (current + 1);
    counter.textContent = srcs.length > 1 ? current + 1 + ' / ' + srcs.length : '';
    prevBtn.hidden = nextBtn.hidden = srcs.length < 2;
  }

  function go(step) {
    if (srcs.length > 1) show(current + step);
  }

  function open() {
    if (!box) build();
    var list = photoList();
    srcs = list.srcs;
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('pdp-lightbox-open');
    show(list.index);
    closeBtn.focus();
  }

  function close() {
    box.hidden = true;
    document.documentElement.classList.remove('pdp-lightbox-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'Tab') {
      // keep focus inside the viewer
      var f = Array.prototype.filter.call(box.querySelectorAll('button'), function (b) { return !b.hidden; });
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  }

  function bindGestures() {
    var pointers = {};
    var startDist = 0, startScale = 1, startMid = null;
    var dragStart = null, moved = false, lastTap = 0;

    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var p = stagePoint(e.clientX, e.clientY);
      zoomAt(scale * (e.deltaY < 0 ? 1.2 : 1 / 1.2), p.x, p.y, false);
    }, { passive: false });

    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      stage.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      moved = false;
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        startDist = Math.hypot(a.x - b.x, a.y - b.y);
        startScale = scale;
        startMid = stagePoint((a.x + b.x) / 2, (a.y + b.y) / 2);
        dragStart = null;
      } else {
        dragStart = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2 && startDist) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        moved = true;
        zoomAt(startScale * (d / startDist), startMid.x, startMid.y, false);
      } else if (dragStart) {
        var dx = e.clientX - dragStart.x, dy = e.clientY - dragStart.y;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
        if (scale > 1) {
          tx = dragStart.tx + dx;
          ty = dragStart.ty + dy;
          clamp();
          apply(false);
          img.style.cursor = 'grabbing';
        }
      }
    });

    function end(e) {
      if (!pointers[e.pointerId]) return;
      var wasPinch = Object.keys(pointers).length === 2;
      delete pointers[e.pointerId];
      if (wasPinch) { startDist = 0; dragStart = null; return; }
      if (!dragStart) return;
      var dx = e.clientX - dragStart.x;
      if (scale === 1 && moved && Math.abs(dx) > 50) {
        go(dx < 0 ? 1 : -1); // swipe between photos when not zoomed
      } else if (!moved) {
        var now = Date.now();
        var p = stagePoint(e.clientX, e.clientY);
        if (e.pointerType === 'mouse') {
          zoomAt(scale > 1 ? 1 : TAP_SCALE, p.x, p.y, true); // click toggles zoom
        } else if (now - lastTap < 300) {
          zoomAt(scale > 1 ? 1 : TAP_SCALE, p.x, p.y, true); // double-tap toggles zoom
          lastTap = 0;
        } else {
          lastTap = now;
        }
      }
      if (scale > 1) img.style.cursor = 'grab';
      dragStart = null;
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    window.addEventListener('resize', function () { if (box && !box.hidden) { clamp(); apply(false); } });
  }

  main.style.cursor = 'zoom-in';
  main.addEventListener('click', open);
  hint.addEventListener('click', open);
})();
